
import { saveAs } from 'file-saver'

import { EventAttributes, createEvents } from 'ics'
import { CalendarEntry } from '../backendServices/BackendServices'
import { EventDate } from '../backendServices/Types'
import { defaultLogger as logger } from "../globalStates/AppState"
import { isSafari } from 'react-device-detect';


export const saveMeetings = (strings: any, meetings: CalendarEntry[]) => {
    const events = meetings.map(x => toMeeting(strings, x))
    const name = (meetings.length === 1 ? meetings[0].title : 'meetings') + '.ics'
    const result = createEvents(events)
    if (result.error) {
        logger.error("ICal saveMeetings", result.error)
    } else {
        logger.info("ICal saveMeetings", result.value)
        const blob = new Blob([result.value!], { type: "text/calendar" })
        saveAs(blob, name)
    }
}

export const saveEvent = (event: EventDate) => {
    const eventToExport = toEvent(event)
    const name = event.name + '.ics'
    const result = createEvents([eventToExport])
    if (result.error) {
        logger.error("ICal saveEvent", result.error)
    } else {
        logger.info("ICal saveEvent", result.value)
        const blob = new Blob([result.value!], { type: "text/calendar" })
        saveAs(blob, name)
    }
}

const toEvent: ((eventDate: EventDate) => EventAttributes) = (eventDate) => {
    let start = new Date(eventDate.startdatetime)
    let end = new Date(eventDate.enddatetime)

    if(isSafari){
        start = new Date(eventDate.startdatetime.replaceAll("-", "/"))
        end = new Date(eventDate.enddatetime.replaceAll("-", "/"))
    }

    var personsWithFunctionNameSorted = eventDate.persons.sort((a, b) => {
        if (a.personFunctionTargetName === undefined && b.personFunctionTargetName === undefined) {
            return 0
        } else if (a.personFunctionTargetName === undefined) {
            return 1
        } else if (b.personFunctionTargetName === undefined) {
            return -1
        } else {
            return a.personFunctionTargetName > b.personFunctionTargetName ? -1 : (a.personFunctionTargetName < b.personFunctionTargetName ? 1 : 0)
        }
    })

    var description = ""

    personsWithFunctionNameSorted.forEach(x => description += '\n' + [x.firstName, x.lastName].filter(Boolean).join(" ") + " (" + x.personFunctionName + ")")

   
    if (eventDate.teaser) {
        description += '\n\n' + eventDate.teaser
    }

    const event: EventAttributes = {
        start: [start.getUTCFullYear(), start.getUTCMonth() + 1, start.getUTCDate(), start.getUTCHours(), start.getUTCMinutes()],
        startInputType: 'utc',
        end: [end.getUTCFullYear(), end.getUTCMonth() + 1, end.getUTCDate(), end.getUTCHours(), end.getUTCMinutes()],
        endInputType: 'utc',
        title: eventDate.name,
        description: description
    }
    return event
}

const toMeeting: ((strings: any, meeting: CalendarEntry) => EventAttributes) = (strings, meeting) => {
    const start = new Date(meeting.start)
    const end = new Date(meeting.end)
    var description = strings.organizer + ': ' + meeting.user.name + '\n\n' + strings.attendees

    meeting.participants.items.filter(x => x.userId !== meeting.userId).forEach(x => description += '\n' + x.user.name)
    if (meeting.description) {
        description += '\n\n' + meeting.description
    }

    const event: EventAttributes = {
        start: [start.getUTCFullYear(), start.getUTCMonth() + 1, start.getUTCDate(), start.getUTCHours(), start.getUTCMinutes()] ,
        startInputType: 'utc',
        end: [end.getUTCFullYear(), end.getUTCMonth() + 1, end.getUTCDate(), end.getUTCHours(), end.getUTCMinutes()],
        endInputType: 'utc',
        title: meeting.title,
        description: description
    }
    return event
}
